import React, { useEffect, useRef, useState } from "react";
import { useApi } from "common/utils/api";
import { useSilentDownload } from "../../common/hooks/useSilentDownload";
import { HTTP_QUERIES } from "common/utils/apiQueries/httpQueries";

export function useExports() {
  const api = useApi();

  const intervalRef = useRef(null);
  const [nbExports, setNbExports] = useState(0);
  const { silentDownload } = useSilentDownload();

  const stopPolling = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const updateExports = async () => {
    let res;
    try {
      res = await api.jsonHttpQuery(HTTP_QUERIES.checkOutExports);
    } catch (err) {
      console.error(err);
      return;
    }
    setNbExports(res?.nb_wip_exports || 0);

    for (const dlUrl of res?.ready_exports_links ?? []) {
      silentDownload(dlUrl);
    }

    if ((res?.nb_wip_exports || 0) === 0) {
      stopPolling();
    }
  };

  const startPolling = () => {
    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => {
        updateExports();
      }, 5000);
    }
  };

  const addExport = async () => {
    startPolling();
    setTimeout(() => {
      updateExports();
    }, 1000);
  };

  useEffect(() => {
    if (nbExports > 0) {
      startPolling();
    }
  }, [nbExports]);

  useEffect(() => {
    return () => stopPolling();
  }, []);

  const cancelExports = async () => {
    const res = await api.jsonHttpQuery(HTTP_QUERIES.cancelExports);
    if (res?.result === "ok") {
      setNbExports(0);
    }
  };

  return {
    updateExports,
    addExport,
    nbExports,
    cancelExports
  };
}
